import React from "react";

function Edit({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5625 3.125L15.375 5.9375C15.5 6.0625 15.5 6.25 15.375 6.375L8.5625 13.1875L5.65625 13.5C5.28125 13.5625 4.9375 13.2188 5 12.8438L5.3125 9.9375L12.125 3.125C12.25 3 12.4375 3 12.5625 3.125ZM17.625 2.40625C18.0938 2.875 18.0938 3.65625 17.625 4.125L16.5312 5.21875C16.4062 5.34375 16.2188 5.34375 16.0938 5.21875L13.2812 2.40625C13.1562 2.28125 13.1562 2.09375 13.2812 1.96875L14.375 0.875C14.8438 0.40625 15.625 0.40625 16.0938 0.875L17.625 2.40625ZM12 11.3438C12 11.2188 12.0312 11.125 12.0938 11.0625L13.3438 9.8125C13.5938 9.59375 14 9.75 14 10.0938V15C14 15.8438 13.3125 16.5 12.5 16.5H1.5C0.65625 16.5 0 15.8438 0 15V4C0 3.1875 0.65625 2.5 1.5 2.5H10.4062C10.75 2.5 10.9062 2.90625 10.6875 3.15625L9.4375 4.40625C9.375 4.46875 9.28125 4.5 9.15625 4.5H2V14.5H12V11.3438Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Edit;
